export function isAbsoluteUrl(path: string) {
  return /^(?:http|https):\/\//i.test(path);
}
